import { render, staticRenderFns } from "./CookieNotification.vue?vue&type=template&id=36439248&scoped=true&lang=html&"
import script from "./CookieNotification.vue?vue&type=script&lang=js&"
export * from "./CookieNotification.vue?vue&type=script&lang=js&"
import style0 from "./CookieNotification.vue?vue&type=style&index=0&id=36439248&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36439248",
  null
  
)

export default component.exports